import { applyMiddleware, combineReducers, compose, createStore, } from "redux"
import persistState from "redux-localstorage"
import thunk from "redux-thunk"
import { createReducer, } from "redux-orm"

import { orm, } from "orm"

const rootReducer = combineReducers({
  entitiesv2: createReducer(orm),

})

const composeEnhancers =
  (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      trace: true,
      traceLimit: 25,
    })) ||
  compose

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunk),
    persistState(),
  )
)

export default store
